// src/components/BuildingViews/RunecraftingStationView.js
import React from 'react';
import styles from './WorkbenchView.module.css'; // Reuse workbench styles for now

const RunecraftingStationView = ({ playerData, onPlayerAction, onGoBack }) => {
  const buildingLevel = playerData.buildings?.runecraftingStation?.upgradeLevel || 0;

  return (
    <div className={styles.workbenchContainer}>
      {onGoBack && (
        <button 
          className={styles.backButton}
          onClick={onGoBack}
          title="Back to Home"
        >
          ✕
        </button>
      )}
      <div className={styles.workbenchHeader}>
        <img src="/img/buildingItems/runecraftingStation.png" alt="Runecrafting Station" className={styles.workbenchIcon} />
        <div className={styles.workbenchInfo}>
          <h2>Runecrafting Station</h2>
          <p>Level {buildingLevel}</p>
          <p className={styles.description}>
            Create magical runes for spells and enchantments
          </p>
        </div>
      </div>

      <div className={styles.workbenchTips}>
        <h4>🔮 Runecrafting (Coming Soon)</h4>
        <ul>
          <li>Create elemental runes for magic spells</li>
          <li>Requires rare gems and magical components</li>
          <li>Unlock powerful enchantments for equipment</li>
        </ul>
      </div>
    </div>
  );
};

export default RunecraftingStationView; 